/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React from "react";

import { getImage } from "gatsby-plugin-image";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { BgImage } from "gbimage-bridge";

import { apiResolveStrWeak } from "../../../../apiBindings";
import Columns from "../../Columns";
import LinkComponent from "../../LinkComponent";
import SmallShapeContainer from "../../SmallShapeContainer";
import HeadlineItem from "../ContentElement/HeadlineItem";

const Container = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerOuter.left}
    `}
`;

const Image = styled(BgImage)`
    width: 100%;
    height: 150px;
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
`;

const ItemImageContainer = styled.div`
    width: 100%;
    height: 150px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
`;

const regex = /^https?:/;

const DowloadItems = ({ downloadItems, name, headlineNumber }) => {
    const theme = useTheme();

    const textContainerCss = css`
        min-height: 120px;
    `;

    const linkCss = css`
        display: flex;
        max-width: 260px;
        margin: 0 auto;
    `;

    return (
        <Container>
            {name && (
                <HeadlineItem headline={headlineNumber}>{name}</HeadlineItem>
            )}
            <Columns>
                {downloadItems.map((item, index) => {
                    const image = item.image?.src && getImage(item.image.src);

                    return (
                        <Columns.Column
                            key={index}
                            desktop="one-quarter"
                            tablet="half"
                            moblie="full"
                        >
                            <a
                                css={linkCss}
                                href={
                                    regex.test(item.link.href)
                                        ? item.link.href
                                        : apiResolveStrWeak(
                                              item.link.href || "/"
                                          )
                                }
                                target="_blank"
                                rel="noreferrer"
                            >
                                <SmallShapeContainer>
                                    <SmallShapeContainer.ImageContainer>
                                        {image ? (
                                            <Image {...{ image }} />
                                        ) : (
                                            <ItemImageContainer
                                                css={css`
                                                    background-color: ${theme.colors.red.toString()};
                                                `}
                                            />
                                        )}
                                    </SmallShapeContainer.ImageContainer>
                                    <SmallShapeContainer.TextContainer
                                        css={textContainerCss}
                                    >
                                        {item.text}
                                        <LinkComponent
                                            link={{
                                                href: regex.test(item.link.href)
                                                    ? item.link.href
                                                    : apiResolveStrWeak(
                                                          item.link.href || "/"
                                                      ),
                                                text: item.link.text,
                                            }}
                                            icon="arrow-right"
                                        />
                                    </SmallShapeContainer.TextContainer>
                                </SmallShapeContainer>
                            </a>
                        </Columns.Column>
                    );
                })}
            </Columns>
        </Container>
    );
};

export default DowloadItems;
